import { setPlayer1, setPlayer2, setPlayer3, setPlayer4, setPlayer5 } from "../../../config/basketball/sets";
import player1 from "./Player 1.svg";
import player2 from "./Player 2.svg";
import player3 from "./Player 3.svg";
import player4 from "./Player 4.svg";
import player5 from "./Player 5.svg";

export const basketballSetNameToThumbnailMap = new Map([
  [setPlayer1.label, player1],
  [setPlayer2.label, player2],
  [setPlayer3.label, player3],
  [setPlayer4.label, player4],
  [setPlayer5.label, player5],
]);
